module.exports = __webpack_public_path__ + "img/power-on.98eb9e0a.svg";